import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import fadeAnimation from './fadeAnimation';

const fadeInHeightPart = 0.3;

class FadeAnimationContainer extends Component {
    constructor(props) {
        super(props);

        this.ref = React.createRef();
        this.onScroll = this.onScroll.bind(this);
    }

    componentDidMount() {
        const { withoutMountAndLocationUpdate = false } = this.props;
        if (!withoutMountAndLocationUpdate) {
            this.enableFadeInAnimation();
        }
    }

    componentDidUpdate(prevProps) {
        const { location, fade = null, withoutMountAndLocationUpdate } = this.props;
        if (location.pathname !== prevProps.location.pathname && !withoutMountAndLocationUpdate) {
            this.ref.current.style.opacity = 0;
            window.addEventListener('scroll', this.onScroll);
        } else if (fade && fade !== prevProps.fade) {
            if (fade === 'fadeIn') {
                this.ref.current.style.opacity = 0;
                fadeAnimation(this.ref, 'fadeIn', 0);
            } else {
                this.enableFadeOutAnimation();
            }
        }
    }

    componentWillUnmount() {
        this.removeOnScrollListener();
        this.ref = null;
    }

    onScroll() {
        const { external = null, delay, callback } = this.props;
        const { clientHeight } = document.documentElement;
        const eventNode = this.getEventNode(external);
        const { top } = eventNode.getBoundingClientRect();

        if (top <= clientHeight * (1 - fadeInHeightPart)) {
            this.removeOnScrollListener();
            fadeAnimation(this.ref, 'fadeIn', delay, callback);
        }
    }

    getEventNode(external) {
        switch (external) {
        case ('parent'): {
            return this.ref.current.parentNode;
        }
        case ('neighbour'): {
            return this.ref.current.previousElementSibling.lastElementChild
                || this.ref.current.previousElementSibling
                || this.ref.current.parentNode;
        }
        default: {
            return this.ref.current;
        }
        }
    }

    enableFadeInAnimation() {
        const { clientHeight } = document.documentElement;
        const { external = false, delay, callback } = this.props;
        const eventNode = this.getEventNode(external);
        const { top } = eventNode.getBoundingClientRect();

        if (top <= clientHeight * (1 - fadeInHeightPart)) {
            fadeAnimation(this.ref, 'fadeIn', delay, callback);
        } else {
            window.addEventListener('scroll', this.onScroll);
        }
    }

    enableFadeOutAnimation() {
        const { callback } = this.props;
        fadeAnimation(this.ref, 'fadeOut', 0, callback);
    }

    removeOnScrollListener() {
        window.removeEventListener('scroll', this.onScroll);
    }

    render() {
        const { className, children, withoutMountAndLocationUpdate = false } = this.props;
        return (
            <Root
                className={className}
                ref={this.ref}
                withoutMountAndLocationUpdate={withoutMountAndLocationUpdate}
            >
                {children}
            </Root>
        );
    }
}

export default withRouter(FadeAnimationContainer);

const Root = styled.div`
    opacity: ${({ withoutMountAndLocationUpdate }) => (withoutMountAndLocationUpdate ? 1 : 0)};
`;
